

export const SET_WORD = "[WORD VERBATIMS] SET WORD";

export const LOAD_WORD_VERBATIMS_REQUEST = "[WORD VERBATIMS] LOAD_WORD_VERBATIMS_REQUEST";
export const LOAD_WORD_VERBATIMS_SUCCESS = "[WORD VERBATIMS] LOAD_WORD_VERBATIMS_SUCCESS";
export const LOAD_WORD_VERBATIMS_ERROR = "[WORD VERBATIMS] LOAD_WORD_VERBATIMS_ERROR";

export const RADIO_SELECT = "[WORD VERBATIMS] RADIO_SELECT";

export const CHANGE_PAGE = "[WORD VERBATIMS] CHANGE_PAGE";

export const RESET_RADIO = "[WORD VERBATIMS] RESET_RADIO";


// WEBPACK FOOTER //
// ./src/modules/word-verbatims/word-verbatims-action-types.js